import React, { useState, createContext, useContext } from 'react';
import { DriverProgress } from '../types/tombola';
interface DriverContextType {
  driverData: DriverProgress | null;
  setDriverData: (data: DriverProgress) => void;
  isAuthenticated: boolean;
}
const DriverContext = createContext<DriverContextType | undefined>(undefined);
export function DriverProvider({
  children
}: {
  children: ReactNode;
}) {
  const [driverData, setDriverData] = useState<DriverProgress | null>(null);
  return <DriverContext.Provider value={{
    driverData,
    setDriverData,
    isAuthenticated: driverData !== null
  }} data-id="element-146">
      {children}
    </DriverContext.Provider>;
}
export function useDriver() {
  const context = useContext(DriverContext);
  if (context === undefined) {
    throw new Error('useDriver must be used within a DriverProvider');
  }
  return context;
}